import apiClient from "../apiService";
import FingerprintJS from "@fingerprintjs/fingerprintjs";

// get attendence by user
export const sendChatMessage = async (payload) => {
  try {
    const fp = await FingerprintJS.load();
    const result = await fp.get();

    const response = await apiClient.post(
      `/chat?${payload.query ? `query=${payload.query}` : ""}&${
        result.visitorId ? `id=${result.visitorId}` : ""
      }`
    );
    // example response
    // {
    //     "output": "I'm doing well, thanks for asking. I'm ready to help you with any tree or plant-related questions or issues you might have. Whether it's about tree care, pruning, planting, or anything else, feel free to ask and I'll do my best to assist you. How about you, how's your day going?"
    //   }
    return response.data;
  } catch (error) {
    console.error(error);
    return;
  }
};

export const analysePlant = async (file) => {
  try {
    const formData = new FormData();
    formData.append("file", file); // Append the file

    const response = await apiClient.post("/img_upload", formData, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    });
// example response
/*
{
  "disease": [
    {
      "id": "d24ebab7c0155e4b",
      "name": "Animalia",
      "probability": 0.5166,
      "redundant": true,
      "details": {
        "description": "Disorders induced by organisms from the animal kingdom. These pests cause direct damage by feeding on leaves, stems, roots, and other parts of the plant or by inhabiting plant tissues. Pests can also spread bacterial and viral diseases.",
        "treatment": {
          "chemical": [
            "If necessary, apply insecticide, or acaricide."
          ],
          "biological": [
            "Remove pests mechanically. Rub the pests off, or remove infested parts or use a strong stream of water to remove the insect.",
            "Apply ecological products for plant protection (e.g. sticky cards, essential oils, horticultural oil).",
            "Introduce natural enemies - predators, parasites, or diseases (e.g. lady beetles, lacewings, parasitic wasps).",
            "Isolate the infested plant immediately to avoid the infestation from spreading."
          ],
          "prevention": [
            "Encourage the presence of natural enemies (e.g. lady beetles, lacewings, parasitic wasps).",
            "Apply dormant oil (controls pests and diseases during the off-season).",
            "Inspect new plants for signs of an infestation. Inspect the underside of leaves and stem joints."
          ]
        },
        "cause": null,
        "language": "en",
        "entity_id": "d24ebab7c0155e4b"
      }
    },
    {
      "id": "76e471140b1b55e2",
      "name": "Insecta",
      "probability": 0.3671,
      "redundant": true,
      "details": {
        "description": "Class Insecta contains many major plant pests such as aphids and thrips. Damage can be caused by both larval and adult stages. They can cause feeding damage or transmit a bacterial, viral, or fungal infection.",
        "treatment": {
          "chemical": [
            "If necessary, apply insecticide.",
            "Apply suitable insecticide based on plant species and suspected insect species."
          ],
          "biological": [
            "Remove pests mechanically. Rub the pests off, or remove infested parts or use a strong stream of water to remove the insect.",
            "Apply ecological products for plant protection (e.g. sticky cards, essential oils, horticultural oil).",
            "Introduce natural enemies - predators, parasites, or diseases (e.g. lady beetles, lacewings, parasitic wasps).",
            "Isolate the infested plant immediately to avoid the infestation from spreading."
          ],
          "prevention": [
            "Encourage the presence of natural enemies (e.g. lady beetles, lacewings, parasitic wasps).",
            "Apply dormant oil (controls pests and diseases during the off-season).",
            "Inspect new plants for signs of an infestation. Inspect the underside of leaves and stem joints."
          ]
        },
        "cause": null,
        "language": "en",
        "entity_id": "76e471140b1b55e2"
      }
    }
  ],
  "is_plant": {
    "probability": 0.9946203,
    "threshold": 0.5,
    "binary": true
  },
  "is_healthy": {
    "binary": true,
    "threshold": 0.525,
    "probability": 0.813358947634697
  }
}
*/
    return response.data;
  } catch (error) {
    console.error("Error uploading file:", error);
    return error;
  }
};
